import gql from 'graphql-tag'
import { getProvider } from '@/apollo'
import { omit } from 'vue-apollo/lib/utils'

const initialState = {
  person: {
    gender: '',
    firstName: '',
    lastName: '',
    birthDate: '',
    email: '',
    repeatEmail: '',
    phone: ''
  },
  address: {
    street: '',
    houseNumber: '',
    zip: '',
    city: '',
    supplement: ''
  }
}

const CustomerDataModule = {
  namespaced: true,
  state: initialState,
  getters: {
    person: state => {
      return state.person
    },
    address: state => {
      return state.address
    }
  },
  actions: {
    async validate ({ dispatch, commit, state, getters, rootGetters }, { person, address, process = 'ordering' }) {
      commit('setPerson', person)
      const inputVariables = {
        firstName: person.firstName,
        lastName: person.lastName,
        gender: person.gender,
        brand: rootGetters.brand,
        market: 'PUC',
        tariffIdentifier: rootGetters[`checkoutv2/${process}/_cart/targetTariff`].tariffId,
        retailerId: rootGetters.retailerId,
        type: 'DELIVERY'
      }
      const apolloClient = getProvider().defaultClient
      return apolloClient.mutate({
        mutation: gql`mutation ${process} ($validateAddressInput: ValidateAddressInput!) {
          validateAddress (validateAddressInput: $validateAddressInput){
            address {
              street,
              houseNumber,
              zip,
              city,
              supplement
            }
          }
        }`,
        variables: {
          validateAddressInput: {
            ...inputVariables,
            address: address
          }
        }
      }).then((response) => {
        if (response.data.validateAddress.address) {
          commit('setAddress', Object.assign({ supplement: address.supplement }, response.data.validateAddress.address))
        } else {
          throw new Error('Validate Address failed')
        }
      }).catch((error) => {
        throw error
      })
    }
  },
  mutations: {
    setPerson (state, person) {
      state.person = person
    },
    setAddress (state, address) {
      state.address = omit(address, '__typename')
    },
    resetState (state) {
      Object.assign(state, initialState)
    }
  }
}

export default CustomerDataModule
